import { AfterViewInit, ChangeDetectionStrategy, Component, inject, input, OnInit, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { kendoIcons } from '@app/shared/library/kendo-icons';
import { ButtonDirective } from '@progress/kendo-angular-buttons';
import { DropDownListComponent, MultiSelectComponent } from '@progress/kendo-angular-dropdowns';
import { BaseFilterCellComponent, FilterService } from '@progress/kendo-angular-grid';
import { TextBoxComponent } from '@progress/kendo-angular-inputs';
import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-multicheck-filter',
  templateUrl: './multicheck-filter.component.html',
  styleUrls: ['./multicheck-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ButtonDirective,
    DropDownListComponent,
    FormsModule,
    MultiSelectComponent,
    TextBoxComponent,
  ],
})
export class MulticheckFilterComponent extends BaseFilterCellComponent implements OnInit, AfterViewInit {
  readonly isPrimitive = input<boolean>(undefined);
  readonly inFilter = input<CompositeFilterDescriptor>(undefined);
  readonly data = input(undefined);
  readonly textField = input(undefined);
  readonly valueField = input(undefined);
  readonly field = input<string>(undefined);

  public icons = kendoIcons;
  public value: Array<string> = [];
  public types: Array<string> = ['Standard', 'Multiselect'];
  public selectedType: string = 'Standard';
  public standardValue: string = null;
  public hasFilterValue: boolean = false;

  readonly standard = viewChild<TextBoxComponent>('standard');

  constructor() {
    const filterService = inject(FilterService);

    super(filterService);
  }

  public ngOnInit() {
    this.filter = this.inFilter();
  }

  public ngAfterViewInit() {
    this.standard().valueChange.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(value => {
      if (this.filter == null) {
        this.filter = {
          filters: [],
          logic: 'and'
        };
      }

      this.hasFilterValue = value != null && value !== "";

      this.applyFilter(
        this.hasFilterValue ?
          this.updateFilter({
            field: this.field(),
            operator: "contains",
            value: value
          }) :
          this.removeFilter(this.field())
      );
    });
  }

  public filterTypeChange(type) {
    this.selectedType = type;

    if (this.hasFilterValue) {
      this.clearFilter();
    }
  }

  public clearFilter() {
    this.hasFilterValue = false;
    this.value = [];
    this.standardValue = null;
    this.applyFilter(this.removeFilter(this.field()));
  }

  public onChange(value) {
    this.value = value;

    if (value == null || value.length == 0) {
      this.clearFilter();
      return;
    }

    if (this.filter == null) {
      this.filter = {
        filters: [],
        logic: "and"
      };
    }

    let filterExists: boolean = false;

    this.filter.filters.map(m => {
      let composite = m as CompositeFilterDescriptor;
      let thisFilter: boolean = false;

      if (composite.filters != null) {
        composite.filters.map(cm => {
          let fd = cm as FilterDescriptor;

          if (fd.field == this.field()) {
            thisFilter = true;
            filterExists = true;
          }
        });

        if (thisFilter) {
          composite.filters = this.value.map(val => ({
            field: this.field(),
            operator: 'eq',
            value: val
          }))
        }
      }
    });

    if (!filterExists) {
      this.filter.filters.push({
        filters: this.value.map(val => ({
          field: this.field(),
          operator: 'eq',
          value: val
        })),
        logic: 'or'
      })
    }

    this.hasFilterValue = true;

    this.filterService.filter(this.filter);
  }
}